import styled from 'styled-components';

const Small = styled.span`
  font-size: var(--font-size-xs);
`;

export default Small;
